import { render, staticRenderFns } from "./app-navigation.vue?vue&type=template&id=a3a4a28a&scoped=true"
import script from "./app-navigation.ts?vue&type=script&lang=ts&external"
export * from "./app-navigation.ts?vue&type=script&lang=ts&external"
import style0 from "./app-navigation.less?vue&type=style&index=0&id=a3a4a28a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a4a28a",
  null
  
)

export default component.exports